import {
    successColor,
} from "assets/jss/material-dashboard-react.jsx";

const machineStyle = theme => ({
    flex_right: {
        display: "flex",
        flex: 1,
        justifyContent: "flex-end"
    },
    flex_sp_btw: {
        display: "flex",
        flex: 1,
        justifyContent:"space-between",
    },
    btnContainer: {
        margin: "1.33em 0",
        height: "41px"
    },
    cardCategory: {
        color: "#999999",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        paddingTop: "10px",
        marginBottom: "0"
    },
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0"
    },
    cardTitle: {
        color: "#3C4858",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    chartContainer: {
        overflowX: "auto",
        "& svg": {
            minWidth: "700px",
        },
        "& .ct-grid": {
            stroke: "rgba(0, 0, 0, 0.2)"
        },
        "& .ct-label":{
            color: "rgba(0, 0, 0, 0.2)"
        },
        "& .ct-series-a .ct-point, .ct-series-a .ct-line, .ct-series-a .ct-bar, .ct-series-a .ct-slice-donut": {
            stroke: successColor,
        }
    },
    select: {
        width: "100%",
    },
    selectWrapper: {
        margin: "0 1em",
        height: "58px",
        width: "100%",
        maxWidth: "192px",
        top: "6px",
    },
});

export default machineStyle


// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-react/views/machineStyle.jsx